import { NgModule } from '@angular/core';
import { MenuService } from '../../menu/services/menu.service';
import { RouteService } from '../../routing/services/route.service';
import { TenantEditPage } from './edit/edit.page';
import { TenantCreatePage } from './create/create.page';
import { TenantIndexPage } from './index/index.page';
import { FormsModule } from '../../forms/forms.module';
import { DatatablesModule } from '../../datatables/datatables.module';

@NgModule({
    imports: [FormsModule, DatatablesModule],
    exports: [],
    declarations: [TenantIndexPage, TenantCreatePage, TenantEditPage],
    entryComponents: [TenantIndexPage, TenantCreatePage, TenantEditPage],
    providers: [],
})
export class TenantsPagesRoutingModule {

    public constructor(routes: RouteService, menuService: MenuService) {

        routes.add('tenants', TenantIndexPage, 'tenants.index', {
            layout: 'full-width', permission: 'tenant.read'
        });
        routes.add('tenants/create', TenantCreatePage, 'tenants.create', {permission: 'tenant.write'});
        routes.add('tenants/:tenant', TenantEditPage, 'tenants.show', {permission: 'tenant.read'});
        routes.add('tenants/:tenant/edit', TenantEditPage, 'tenants.edit', {permission: 'tenant.read'});

        routes.apply();

        const menu = menuService.get('sidebar');

        menu.get('users')
            .add('tenants', 'Tenants', 'tenants.index', {icon: 'fa fa-tenants', permission: 'tenant.read'});

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/tenants/tenants-pages-routing.module.ts